import { render, staticRenderFns } from "./Solicitacoes.vue?vue&type=template&id=9851bac8"
import script from "./Solicitacoes.vue?vue&type=script&lang=js"
export * from "./Solicitacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports